import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faClock } from '@fortawesome/free-solid-svg-icons';
import { withTranslation } from "react-i18next";
import LinkButton from "./LinkButton";

const LicencesRequiringReview = ({ licences, setSelectedApplicationIdForDetails, t, isLoading, error, icon }) => {
    // Show loading state
    if (isLoading) {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="alert alert-info">
                        <FontAwesomeIcon icon={faClock} className="me-2" />
                        {t("Common.Loading")}
                    </div>
                </div>
            </div>
        );
    }

    // Show error state
    if (error) {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="alert alert-danger">
                        <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
                        {t("Common.ErrorLoadingReviews")}
                    </div>
                </div>
            </div>
        );
    }

    // Show no reviews message
    if (!licences || licences.length === 0) {
        return null;
    }

    // Helper function to format date
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB');
    };

    return (
        <div className="row">
            <div id="LicencesRequiringReviewHeading" role="heading" aria-level="2" className="Sub-Heading-Title" tabIndex="0">
                {t("OwnerLandingPage.LicencesRequiringReviewHeading")}
            </div>
            <div className="row">
                {licences.map(licence => {
                    return (
                        <div key={licence.reviewId || licence.licenceApplicationId} className="col-md-4">
                            <LinkButton 
                                className="btn btn-review-details Shadowing"
                                onClick={() => setSelectedApplicationIdForDetails(licence.licenceApplicationId)}
                                to={"/licence-details-page/" + licence.licenceApplicationId}
                            >
                                <FontAwesomeIcon icon={icon || faExclamationTriangle} className="me-2 text-white" />
                                <div className="h5 mb-2 text-white">
                                    <strong>{t("OwnerLandingPage.LicenceNumber")}</strong> {licence.licenceNumber || licence.LicenceNumber || `LSR${licence.licenceApplicationId}`}
                                </div>
                                <div className="h6 mb-1 text-white">
                                    <strong>{t("OwnerLandingPage.VesselName")}</strong> {licence.vesselName || licence.VesselName}
                                </div>
                                <div className="h6 text-white">
                                    <strong>{t("OwnerLandingPage.ReviewDueDate")}</strong> {formatDate(licence.reviewDueDate || licence.ReviewDueDate)}
                                </div>
                            </LinkButton>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default withTranslation()(LicencesRequiringReview); 